import { supabase } from './supabase';

// Cierre de jornada: fija hasta qué hora se trabajó (todo el comercio, una sede o una persona)
export const closeAttendance = async ({ scope, employeeId = null, locationId = null, closedAt = null, reason = null }) => {
  const { data, error } = await supabase.rpc('admin_close_attendance', {
    p_scope: scope, p_employee: employeeId, p_location: locationId, p_closed_at: closedAt, p_reason: reason,
  });
  if (error) throw error;
  return data;
};
export const reopenClosure = async (id) => {
  const { error } = await supabase.rpc('admin_reopen_closure', { p_id: id });
  if (error) throw error;
};
export const listClosures = async (limit = 15) => {
  const { data, error } = await supabase.rpc('admin_list_closures', { p_limit: limit });
  if (error) throw error;
  return data || [];
};
